<template>
    <div class="editionpay_mobilebox">
        <top_mobile v-show="topshow"></top_mobile>
        <van-form validate-first @failed="onFailed" @submit="onSubmit">

        <div style="height: 44px;background: #202334;width: 24rem;"></div>
        <div class="top">
            <div class="topl">
                <img src="../../public/statics/img/logo.jpg" alt="" @click="jumpediton()">
            </div>
            <div class="topr">
                <p class="topr1">IDA云物流</p>
                <div class="topr2">
                    <div class="topright2s">
                        智慧物流
                    </div>
                    <div class="topright2s">
                        大数据
                    </div>
                    <div class="topright2s">
                        企业赋能
                    </div>
                    <div class="topright2s">
                        工业互联网
                    </div>
                    <div class="topright2s">
                        柔性产线
                    </div>
                </div>
                <div class="topr3">
                    <div class="topr3s">
                        <p>产品形态:</p>
                        <span>集成产品</span>
                    </div>
                    <div class="topr3s">
                        <p>付费模式:</p>
                        <span style=" color:#FBA962;">按租期</span>
                    </div>
                </div>
            </div>
        </div>
<!--输入信息-->
        <div class="second">
                <van-field
                        required
                        maxlength="50"
                        v-model="company"
                        name="company"
                        label="买方企业:"
                        placeholder="请输入"
                        input-align="right"
                        error-message-align="right"
                        :rules="[{ required: true, message: '请输入买方企业', trigger: 'blur' }]"
                />
                <van-field
                        required
                        maxlength="10"
                        v-model="name"
                        name="name"
                        label="联系人:"
                        placeholder="请输入"
                        input-align="right"
                        error-message-align="right"
                        :rules="[{ required: true, message: '请填写联系人' }]"
                />
                <van-field
                        maxlength="15"
                        required
                        v-model="phone"
                        name="phone"
                        label="联系电话:"
                        placeholder="请输入"
                        input-align="right"
                        error-message-align="right"
                        :rules="[{ required: true, message: '请填写联系电话' },
                        { pattern: /^(((\d{3,4}-)?[0-9]{7,8})|(1(3|5|6|7|8|9)\d{9}))$/, message: '手机号码格式错误！'}]"
                />
                <van-field name="time" input-align="left" label="购买时长:"  readonly>

                    <template #input>
                        <div class="botons">12个月</div>
                    </template>
                </van-field>


        </div>
<!--模块-->
        <div class="thrid" v-for="(item,index) in alldata" :index="index">
            <div class="thridone">
                <p class="thrid1">{{item.modular}}</p>
                <div class="thrid2">
                    <div class="thrid2s" :class="[v.focus==true ?'thrid2sfocus':'']" v-for="(v,i) in item.children"
                         :index="i" @click="countser(index,i)">
                        {{v.modular}} | {{v.price}}/年
                    </div>
                </div>
                <div class="thrid3">
                    <p>端口数</p>
                    <i class="el-icon-info" @click="showcontent(index)"></i>
                </div>
                <div class="thrid4">
                    <span>5个起售</span>
                    <van-stepper :disable-input="true"
                                 @change="handleChange(index)" v-model="item.sportnum"
                                 :min="item.sportnumlower"/>
                </div>
            </div>
            <div class="thridtwo">
                <div class="thridtwos">
                    <p>服务模块：</p>
                    <span>￥{{item.model}}</span>
                </div>
                <div class="thridtwos">

                    <p>端口：</p>
                    <span >￥{{item.sport}}</span>
                </div>
            </div>


        </div>
        <div style="height: 60px;background: #202334;width: 24rem;"></div>

        <div class="lastdiv">
            <div class="lastdivl">
                <p>￥{{all}}</p>
                <span @click="lookdetail()">查看明细</span>
            </div>
<!--            <div class="paybutton" native-type="submit">申请购买</div>-->
            <van-button round block type="info" class="paybutton" native-type="submit"  :disabled="buttondis">提交</van-button>
        </div>
        </van-form>


        <van-popup v-model="show" position="bottom" :style="{ height: '160px',borderTopLeftRadius:' 8px',borderTopRightRadius:'8px'}">
            <div class="showscont">
                <p class="showscont1">价格说明</p>
                <div style="width: 100%;
height: 1px;
background: #707070;
opacity: 0.1;
margin:  10px 0"></div>
                <div class="showscont2">
                    <span>梯度</span>
                    <span>端口数</span>
                    <span>销售价(元/年/个)</span>
                </div>
                <div style="width: 100%;
height: 1px;
background: #707070;
opacity: 0.1;
margin:  10px 0"></div>


                <div class="showscont3" >
                    <span>1</span>
                    <span>5~不限</span>
                    <span>￥3600</span>
                </div>



            </div>
        </van-popup>

        <van-popup v-model="detailshow" position="bottom" :style="{ height: '300px',borderTopLeftRadius:' 8px',borderTopRightRadius:'8px'}">
            <div class="showscont">
                <p class="showscont1">查看明细</p>
                <div style="width: 100%;
height: 1px;
background: #707070;
opacity: 0.1;
margin:  10px 0"></div>
                <div class="showscont4" v-for="(item,index) in alldata" :index="index"  v-if="item.model>0">
                    <div class="showscont4s showscont4s1">
                        <div>{{item.modular}}</div>
                        <div>￥{{item.model+ item.sport}}</div>
                    </div>
                    <div class="showscont4s">
                        <div>服务模块费用</div>
                        <div>￥{{item.model}}</div>
                    </div>
                    <div class="showscont4s ">
                        <div>端口费用</div>
                        <div v-if="item.sport==0">免费</div>
                        <div v-else>￥{{item.sport}}</div>
                    </div>
                </div>
                <div class="showscont5">
                    合计:￥{{all}}
                </div>



            </div>
        </van-popup>



    </div>

</template>

<script>
    import {auth, anth} from '../request/api';
    import top_mobile from "../components/top_mobile";
    import {Dialog, Toast} from "vant";
    export default {
        name: "editionpay_mobile",
        components: {
            top_mobile
        },
        data() {
            return {

                topshow: true,
                company: "",
                name: "",
                phone: "",


                modelall: 0,
                sportall: 0,
                all: 0,//总计

                /*普惠云服务模块*/
                alldata: [],

                show: false,//端口解释
                detailshow:false,//明细查看

                showlist: [
                    {
                        gradient: 1,
                        sportnum: 1,
                        sportprice: "免费",
                    },
                    {
                        gradient: 1,
                        sportnum: '5~不限',
                        sportprice: "￥3600",
                    },
                ],
                buttondis:false,

            }
        },
        mounted() {
            window.addEventListener('scroll', this.handleScrollx, true)
            this.getmodular();
            this.count();
        },
        methods: {
            handleScrollx() {
                if (window.pageYOffset > 20) {
                    this.topshow = false;
                } else {
                    this.topshow = true;
                }
                ;
            },
            getmodular(){
                let url='/v1/website/offer/modular';
                auth(url).then(res=>{
                    if (res.data.code==1){
                        let arr=JSON.parse(JSON.stringify(res.data.data));
                        arr.forEach(v=>{
                            v.model=0;//声明模块费用，
                            v.sport=0;//声明端口费用
                            v.sportprice=3600;//声明端口价格
                            v.sportnumlower=Number(v.sportnumlower);
                            v.sportnum=Number(v.sportnum);
                            v.children.forEach(s=>{
                                s.sportnumlower=Number(s.sportnumlower);
                                s.sportnum=Number(s.sportnum)
                            })
                        })
                        this.alldata=arr;
                    } else{
                        this.$message({
                            type:'error',
                            message:res.data.msg
                        });
                    }
                })
            },

            countser(index,inds){
                if(inds==0){
                    this.alldata[index].children[inds].focus=!this.alldata[index].children[inds].focus;
                    if(this.alldata[index].children[inds].focus==false){
                        this.alldata[index].children.forEach(e=>{
                            e.focus=false;
                        })
                    }
                }else if(inds>0){
                    this.alldata[index].children[inds].focus=!this.alldata[index].children[inds].focus;
                    this.alldata[index].children[0].focus=true;
                }
                this.count();
            },
            count(){
                this.modelall=0;
                this.sportall=0;
                this.all=0;
                this.alldata.forEach((e,i)=>{
                    let price=[];
                    e.children.forEach(v=>{
                        if(v.focus==true){
                            price.push(Number(v.price));
                        }
                        // if(i==0){
                        //     e.sportprice=0;
                        // }
                    });
                    if(price.length!=0){
                        this.alldata[i].model=price.reduce((n,m) => n +m);//求和
                        this.alldata[i].sport=Number(this.alldata[i].sportnum) * Number(this.alldata[i].sportprice);
                    }else{
                        this.alldata[i].model=0;//求和
                        this.alldata[i].sport=0;
                    }
                    this.modelall+=Number(e.model);
                    this.sportall+=Number(e.sport);
                });
                this.all=Number(this.modelall)+Number(this.sportall);

            },
            handleChange(index){
                this.alldata[index].sport=Number(this.alldata[index].sportnum) * Number(this.alldata[index].sportprice);
                this.count();
            },

            showcontent(index) {
                this.show = true;
            },
            lookdetail(){
                if(this.all>0){
                    this.detailshow=true;
                }else{
                    Toast('请选择模块服务！')
                }

            },


            //提交
            onSubmit(values) {
                this.buttondis=true;
                if(this.all>0){

                    let arr=[];
                    this.alldata.forEach(v=>{
                        let obj={
                            id:v.id,
                            port:'',
                            model:[],
                        };
                        v.children.forEach(s=>{
                            if(s.focus==true){
                                obj.model.push(s.id);
                                obj.port=v.sportnum;
                            }
                        });
                        arr.push(obj);
                    });


                    let url='/v1/website/offer/apply';
                    let data={
                        company_name:values.company,
                        tel_name:values.name,
                        phone:values.phone,
                        buy_time:'12个月',
                        //普惠云
                        // inclusive:arr[0].model.toString(),
                        // i_port:arr[0].port,
                        transport:arr[0].model.toString(),
                        t_port:arr[0].port,
                        packaging:arr[1].model.toString(),
                        p_port:arr[1].port,
                        warehouse:arr[2].model.toString(),
                        w_port:arr[2].port,
                        modular_cost:this.modelall,
                        port_cost:this.sportall,
                        all_cost:this.all,
                    };

                    auth(url,data).then(res=>{
                        if(res.data.code==1){
                          setTimeout(()=>{
                            this.buttondis=false;
                          },1000)
                          Dialog.alert({
                            message: '感谢您的购买，我们的销售员会尽快联系您!',
                            className: 'custom-dialog',
                          }).then(() => {
                            this.$router.push('/edition_mobile')
                          });
                        }else{
                            Toast(res.data.msg);
                            setTimeout(()=>{
                                this.buttondis=false;
                            },1000)
                        }
                    })

                }else{
                    Toast('请选择模块服务！')
                }
            },
            onFailed(errorInfo) {
                this.buttondis=true;
                console.log('failed', errorInfo);
                Toast(errorInfo.errors[0].message)

                setTimeout(()=>{
                    this.buttondis=false;
                    console.log(this.buttondis);

                },1000)
            },
        },

    }
</script>

<style scoped lang='scss'>
    .editionpay_mobilebox {
        width: 100%;
        height: auto;
        background: #F5F7FB;

        .top {
            width: 24rem;
            height: auto;
            background: #FFF;
            display: flex;
            justify-content: flex-start;

            .topl {
                width: 100px;
                height: auto;
                box-sizing: border-box;
                margin-right: 5px;
                display: flex;
                align-items: center;

                img {
                    width: 100%;
                }
            }

            .topr {
                width: calc(24rem - 100px);
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: space-around;
                padding: 10px 0;
                box-sizing: border-box;

                .topr1 {
                    font-size: 24px;
                    font-family: "PingFang SC";
                    color: #333333;
                }

                .topr2 {
                    display: flex;
                    flex-wrap: wrap;

                    .topright2s {
                        width: auto;
                        padding: 0 6px;
                        height: 18px;
                        line-height: 18px;
                        font-size: 12px;
                        color: #8AC7F8;
                        border: 1px solid #8AC7F8;
                        opacity: 1;
                        border-radius: 100px;
                        margin-bottom: 3px;
                        margin-right: 5px;

                    }
                }

                .topr3 {
                    display: flex;

                    .topr3s {
                        display: flex;
                        flex-wrap: wrap;
                        font-family: 'PingFang SC';
                        margin-right: 5px;
                        letter-spacing: 1px;

                        p {
                            font-size: 12px;

                            color: #999999;
                        }

                        span {
                            color: #333333;
                        }


                    }
                }

            }
        }

        .second {
            width: 24rem;
            height: auto;
            background: #ffffff;
            margin-top: 10px;

            .botons {
                width: 58px;
                height: 22px;
                background: #4781F5;
                opacity: 1;
                border-radius: 100px;
                text-align: center;
                color: #ffffff;
            }
        }

        .thrid {
            margin-top: 10px;

            width: 24rem;
            height: auto;
            background: #ffffff;
            box-sizing: border-box;
            margin-bottom: 10px;

            .thridone {
                width: 100%;
                padding: 5px 10px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                border-bottom: 1px solid rgba(112, 112, 112, 0.1);

                .thrid1 {
                    font-size: 24px;
                    font-family: "PingFang SC";
                    margin-bottom: 10px;

                }

                .thrid2 {
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    box-sizing: border-box;

                    .thrid2s {
                        width: auto;
                        height: 30px;
                        line-height: 30px;
                        padding: 0 10px;
                        font-size: 14px;
                        background: #EBEBEB;
                        border-radius: 8px;
                        box-sizing: border-box;
                        margin-bottom: 5px;
                        border: 1px solid #EBEBEB;

                    }

                    .thrid2sfocus {
                        background: #EBEBEB;
                        border: 1px solid #4781F5;
                        box-sizing: border-box;
                        color: #4781F5;
                    }
                }

                .thrid3 {
                    margin-top: 10px;
                    display: flex;
                    align-items: center;

                    p {
                        font-size: 16px;
                        font-family: "PingFang SC";
                        color: #333;
                        margin-right: 5px;
                    }

                    i {
                        color: #FF9A26;
                        font-size: 20px;
                    }
                }

                .thrid4 {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 5px;

                    span {
                        font-size: 12px;
                        font-family: PingFang SC;
                        color: #999;
                    }

                }

            }

            .thridtwo {
                width: 100%;
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding-right: 10px;
                box-sizing: border-box;

                .thridtwos {
                    width: 130px;
                    display: flex;
                    justify-content: flex-end;
                    font-size: 12px;
                    font-family: PingFang SC;
                    color: #999999;

                    span {
                        color: #FF9A26;
                    }

                }
            }

        }

        .lastdiv {
            width: 24rem;
            height: 60px;
            padding: 0 10px;
            box-sizing: border-box;
            position: fixed;
            bottom: 0;
            background: #ffffff;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-shadow: 0px -3px 12px rgba(0, 0, 0, 0.07);

            .lastdivl {
                display: flex;
                flex-direction: column;
                justify-content: center;

                p {
                    font-size: 20px;
                    font-family: ' PingFang SC';
                    color: #FF9A26;
                }

                span {
                    font-size: 14px;
                    font-family: PingFang SC;
                    color: #4781F5;
                }
            }

            .paybutton {
                width: 113px;
                height: 36px;
                background: #3D68EB;
                border-radius: 8px;
                font-family: "PingFang SC";
                color: #fff;
                line-height: 36px;
                letter-spacing: 1px;
                font-size: 16px;
            }

            .paybutton:active {
                background: rgba(61, 104, 235, 0.85)
            }

        }


        .showscont {
            width: 100%;
            padding: 10px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            .showscont1 {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 800;
                line-height: 41px;
                color: #333333;
            }
            .showscont2{
                font-size: 16px;
                font-family: PingFang SC;

                color: #333333;
                width: 100%;
                display: flex;
                justify-content: space-between;
                span{
                    width: 30%;
                    text-align: left;
                }
                span:last-child{
                    width: 40%;
                }
            }
            .showscont3{
                width: 100%;
                font-size: 16px;
                font-family: PingFang SC;

                color: #333333;
                display: flex;
                justify-content: space-between;
                span{
                    width: 30%;
                    text-align: left;
                }
                span:last-child{
                    width: 40%;
                }
            }
            .showscont4{
                width: 100%;
                display: flex;
                flex-direction: column;
                border-bottom: 1px solid rgba(112,112,112,0.1);
                font-family: "PingFang SC";
                .showscont4s{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    font-size: 12px;
                    line-height: 41px;
                    color: #999999;
                }
                .showscont4s1{
                    font-size: 16px;
                    line-height: 41px;
                    color:#333;
                }
            }
            .showscont5{
                width: 100%;
                display: flex;
                justify-content: flex-end;
                font-size: 16px;
                font-family: 'PingFang SC';
                font-weight: 400;
                line-height: 41px;
                color: #FF9A26;
            }
        }

    }
</style>
<style lang="scss">
.custom-dialog .van-dialog__confirm {
  color: #3D68EB; /* 确认按钮颜色 */
}
</style>